import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Contestant } from '@/types';

interface AuthState {
  user: Contestant | null;
  token: string | null;
  isAuthenticated: boolean;
  loading: boolean;
  setAuth: (user: Contestant, token: string) => void;
  logout: () => void;
  updateUser: (user: Partial<Contestant>) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      loading: false,
      setAuth: (user, token) => set({ user, token, isAuthenticated: true, loading: false }),
      logout: () => {
        set({ user: null, token: null, isAuthenticated: false });
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      },
      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),
      setLoading: (loading) => set({ loading }),
    }),
    {
      name: 'auth-storage',
    }
  )
);
